<template>
  <AppModalEdit
    v-model="isActive"
    :loading="loading"
    :is-exec-button-disabled="!editedItem.validation"
    @clickExec="saveEditedItem"
    title="アカウント編集"
    exec-button-text="保存"
  >
    <SelectUserType
      v-model="editedItem.userType"
      :permission="item.permission"
      :is-system-owner="item.isSystemOwner"
      caution="現在ログイン中のユーザよりも上位の権限を持つユーザへの切り替えは、上位のユーザーに依頼してください。"
    />
    <!-- todo readonlyとかフラグ渡す-->
    <v-layout pt-4>
      <AppForm label="名前">
        <v-text-field v-model="editedItem.name" browser-autocomplete="off" />
      </AppForm>
    </v-layout>
    <v-layout pt-4>
      <AppForm label="ステータス">
        <v-switch
          v-model="editedItem.status"
          true-value="active"
          false-value="inactive"
        />
      </AppForm>
    </v-layout>
  </AppModalEdit>
</template>

<script>
import SelectUserType from './SelectUserType'
import { actions, snackbarType } from '@/vuex/modules/ui/snackbar/constants'
import { EditAccountForm } from '@/models/Account'
export default {
  name: 'ModalEdit',
  components: { SelectUserType },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      editedItem: {},
      loading: false,
    }
  },
  computed: {
    isActive: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  watch: {
    value(newVal) {
      if (newVal) this.editedItem = new EditAccountForm(this.item)
    },
  },
  methods: {
    async saveEditedItem() {
      this.loading = true
      try {
        await this.editedItem.execEdit()
        await this.$store.dispatch(actions.SHOW_SNACKBAR, {
          type: snackbarType.SUCCESS,
          message: '保存完了しました',
        })
        this.isActive = false
        this.$emit('save')
      } catch (e) {
        const error = new Error('保存に失敗しました。')
        throw error
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
.v-input {
  padding: 0;
  margin: 0;
}
</style>
